import React from 'react';
import './Header.css'; 
import logo from "./assets/Banner.webp";
import headerBg from './assets/HeaderBg.png';

const Header = () => {
  return (
    <header className="header">
    <div className="logo-container">
        <img src={logo} alt="Game Logo" class="logo-image"/>
    </div>
    <nav>
      <a href="#about">About</a>
      <a href="#instructions">Instructions</a>
    </nav>
    </header>
  );
};

export default Header;
